<!--
 * NOTE
 * 等 API 完成後，再來替換
 * 然後再調整匯出的部分
 -->
<script>
import SearchView from "@/components/SearchView";
import TableView from "@/components/TableView";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";
import OrderDetail from "@/pages/order/OrderDetail";
export default {
  name: "Index",
  components: {
    OrderDetail,
    TableView,
    SearchView,
  },
  mixins: [common],
  data() {
    return {
      status: 0,
      loading: false,
      searchKey: "",
      searchValue: "",
      pagination: {
        page: 1,
        itemsPerPage: 25,
        totalItems: 0,
      },
      list: [],
      editView: {
        visible: false,
        item: null,
        showCancel: true,
        confirmEvent: () => {},
        cancelEvent: () => {},
      },
      startDate: "",
      endDate: "",
      vendorList: [],
      selectVendor: "",
    };
  },
  created() {
    this.loadVendorList();
    if (this.isVendor) {
      this.selectVendor = this.getUserInfo.userId;
    }
    this.loadData();
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    getColumnKeys() {
      // 獎品編號/獎品圖片/獎品名稱/email/暱稱/所屬廠商/獲得時間
      return [
        { value: "prizeId", text: "獎品編號", sortable: true },
        {
          value: "imageUrl",
          text: "獎品圖片",
          sortable: true,
          isImage: true,
        },
        { value: "category", text: "賞別", sortable: true },
        { value: "name", text: "獎品名稱", sortable: true },
        { value: "price", text: "抽價", sortable: true },
        { value: "deliveryPrice", text: "運費", sortable: true },
        { value: "weight", text: "體積", sortable: true },
        { value: "email", text: "email", sortable: true },
        { value: "nickname", text: "暱稱", sortable: true },
        { value: "vendorName", text: "所屬廠商", sortable: false },
        { value: "createdDate", text: "獲得時間", sortable: false },
      ];
    },
    getSearchKeys() {
      if (this.isAdmin || this.isStaff) {
        return [
          { key: "email", value: "Email" },
          { key: "nickname", value: "暱稱" },
          { key: "category", value: "賞別" },
          { key: "name", value: "獎品名稱" },
          { key: "weight", value: "體積" },
          { key: "vendorName", value: "所屬廠商" },
        ];
      } else {
        return [
          { key: "nickname", value: "暱稱" },
          { key: "name", value: "獎品名稱" },
        ];
      }
    },
  },
  methods: {
    ...mapActions(["getNotShippedList", "getVendorList"]),
    async loadVendorList() {
      try {
        const res = await this.getVendorList();
        const result = res.data;
        if (result.statusCode === 0) {
          this.vendorList = result.data;
        }
      } catch (e) {
        console.log(`getVendorList error `, e);
      }
    },
    async loadData() {
      try {
        let searchQuery = [];
        // searchQuery.push({ key: "shippingStatus", value: this.status });
        if (this.searchKey !== "" && this.searchValue !== "") {
          searchQuery.push({ key: this.searchKey, value: this.searchValue });
        }
        if (this.isVendor) {
          searchQuery.push({ key: "vendorId", value: this.getUserInfo.userId });
        }
        if ((this.isAdmin || this.isStaff) && this.selectVendor !== "") {
          searchQuery.push({ key: "vendorId", value: this.selectVendor });
        }

        this.loading = true;
        const res = await this.getNotShippedList({
          pageIndex: this.pagination.page,
          limit: this.pagination.itemsPerPage,
          startDate: `${this.startDate} 00:00:00`,
          endDate: `${this.endDate} 23:59:59`,
          searchQuery: searchQuery,
        });

        if (res.data.statusCode === 0) {
          this.list = res.data.data.list;
          this.pagination.totalItems = res.data.data.header.totalCount;

          console.log(`getOrderList ${JSON.stringify(this.list)}`);
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(`getOrderList error`, e.stack);
      }
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page) {
      this.pagination.page = page.page;
      if (page.itemsPerPage === -1) {
        this.pagination.itemsPerPage = 1000;
      } else {
        this.pagination.itemsPerPage = page.itemsPerPage;
      }
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell) {
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === "print") {
        let routeData = this.$router.resolve({
          path: "/OrderView",
          query: {
            orderId: cell.item.orderId,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (cell.key === "delete") {
        // this.showAlert({
        //   title: '提示',
        //   content: '是否確定要刪除此商品？',
        //   confirmEvent: async () => {
        //     this.hideAlert();
        //     await this.deleteEvent(cell.item);
        //   }
        // });
      } else {
        this.editView.title = cell.key === "add" ? "新增訂單" : "修改訂單";
        this.editView.item = cell.item;
        this.editView.visible = true;
        this.editView.cancelEvent = () => {
          this.editView.visible = false;
        };
        this.editView.confirmEvent = () => {
          this.editView.visible = false;
          this.loadData();
        };
      }
    },
    searchEvent(info) {
      this.startDate = info.startDate;
      this.endDate = info.endDate;
      this.searchKey = info.searchKey;
      this.searchValue = info.searchValue;

      this.loadData();
    },
    reset() {
      this.searchValue = "";
      if (this.isAdmin || this.isStaff) {
        this.selectVendor = "";
      }
      this.loadData();
    },
    getPaymentTypeForExport(paymentType) {
      const paymentTypes = {
        point: "代幣",
        bonus: "紅利",
        freeTicket: "免運券",
        credit_card: "信用卡",
        paypal: "PayPal",
        // 其他付款方式
      };
      return paymentTypes[paymentType] || "未知";
    },
    getStoreTypeForExport(shippingType) {
      const shippingTypes = {
        UNIMARTC2C: "7-ELEVEN交貨便",
        FAMIC2C: "全家店到店",
        HILIFEC2C: "萊爾富店到店",
        OKMARTC2C: "OK超商店到店",
        POST: "宅配-本島運送",
        "POST-out": "宅配-離島運送",
        PICKUP: "自取",
        "POST-international": "國際配送",
        express: "快遞",
        standard: "標準",
        // 其他運送方式
      };
      return shippingTypes[shippingType] || "未知";
    },
    // 匯出 excel
    async exportToExcel() {
      try {
        const XLSX = require("xlsx"); // 動態導入xlsx
        // 使用 list 的數據
        const exportList = this.list.map((item) => ({
          獎品編號: item.prizeId,
          獎品圖片: item.imageUrl,
          賞別: item.category,
          獎品名稱: item.name,
          抽價: item.price,
          運費: item.deliveryPrice,
          體積: item.weight,
          Email: item.email,
          暱稱: item.nickname,
          所屬廠商: item.vendorName,
          獲得時間: item.createdDate,
        }));

        // 創建一個工作表
        const worksheet = XLSX.utils.json_to_sheet(exportList);

        // 創建一個工作簿並將工作表添加進去
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // 將工作簿導出為Excel文件
        XLSX.writeFile(workbook, "未出貨列表.xlsx");
      } catch (e) {
        console.log(`export error `, e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <v-container fluid>
    <v-layout v-if="isAdmin || isStaff">
      <v-flex md4 xs12>
        <v-select
          class="ml-1"
          :items="vendorList"
          v-model="selectVendor"
          label="篩選廠商"
          item-value="vendorId"
          item-text="name"
          :color="Theme.GREEN"
        ></v-select>
      </v-flex>
      <v-flex md7></v-flex>
      <v-flex md1>
        <v-btn :color="Theme.GREEN" dark @click="exportToExcel"
          >匯出 Excel</v-btn
        >
      </v-flex>
    </v-layout>

    <search-view
      :show-search-options="true"
      :search-options="getSearchKeys"
      :show-search-date-options="false"
      :show-search-date="true"
      :show-add-button="false"
      @initEvent="searchEvent"
      @searchEvent="searchEvent"
      @reset="reset"
    ></search-view>

    <!-- <v-layout>
      <v-radio-group v-model="status" row>
        <v-radio label="待出貨" :value="0" :color="Theme.GREEN"></v-radio>
        <v-radio label="備貨中" :value="5" :color="Theme.GREEN"></v-radio>
        <v-radio label="已出貨" :value="1" :color="Theme.GREEN"></v-radio>
        <v-radio label="已完成" :value="2" :color="Theme.GREEN"></v-radio>
        <v-radio label="已退貨" :value="3" :color="Theme.GREEN"></v-radio>
        <v-radio label="未取貨" :value="4" :color="Theme.GREEN"></v-radio>
      </v-radio-group>
    </v-layout> -->

    <v-layout>
      <v-flex>
        <table-view
          :items="list"
          :columnKeys="getColumnKeys"
          :pagination="pagination"
          :loading="loading"
          @changePage="changePage"
          @cellEvent="cellEvent"
        />
      </v-flex>
    </v-layout>

    <order-detail
      :title="editView.title"
      :visible="editView.visible"
      :item-detail="editView.item"
      :show-cancel="editView.showCancel"
      @cancelEvent="editView.cancelEvent"
      @confirmEvent="editView.confirmEvent"
      @reloadEvent="loadData"
    >
    </order-detail>
  </v-container>
</template>

<style scoped></style>
